var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9883 0H0V3.2527H39.9883V0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H36.7473V39.9883H40V0Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9883 36.7473H0V40H39.9883V36.7473Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.2527 0H0V39.9883H3.2527V0Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7433 32.2588V22.5007C30.7433 19.0382 27.9103 16.2052 24.4477 16.2052C20.9852 16.2052 18.1522 19.0382 18.1522 22.5007V32.2588H21.3V22.5007C21.3 20.7636 22.7223 19.353 24.4477 19.353C26.1732 19.353 27.5955 20.7753 27.5955 22.5007V32.2588H30.7433ZM11.3553 32.2588H14.5031V16.52H11.3553V32.2588ZM11.3553 13.3722H14.5031V10.2244H11.3553V13.3722Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0225 15.1676C15.1093 15.1676 16.7998 13.4771 16.7998 11.3903C16.7998 9.30342 15.1093 7.61295 13.0225 7.61295C10.9356 7.61295 9.24515 9.30342 9.24515 11.3903C9.24515 13.4771 10.9356 15.1676 13.0225 15.1676Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.ba2cf424b2ddaa3573f5e9604736c729.svg";
export { ForwardRef as ReactComponent };